export const isWeixin = () => {
    return /MicroMessenger/.test(window.navigator.userAgent);
}

